import React from 'react';
import { Form, FormItem, Input, Button } from '../../../../../components';
import { SearchIcon } from '../../../../../components/SearchBar/SearchIcon';
import AddIcon from '@mui/icons-material/Add';
import { LABELS } from '../constants';
import type { SearchPanelProps, HeaderActionsProps } from '../types';

type SourceTableHeaderProps = SearchPanelProps & HeaderActionsProps;

export const SourceTableHeader: React.FC<SourceTableHeaderProps> = ({
  filters,
  onFiltersChange,
  onRagSearch,
  onAddDataSource,
}) => {
  return (
    <div className="flex flex-wrap justify-between items-center mb-4 gap-y-4">
      <div className="flex gap-x-sm justify-between">
        <Form initialValue={filters || {}} onChange={onFiltersChange}>
          <FormItem inline={false} name="name" label="">
            <Input
              placeholder="Search"
              inputClassName="pl-20 text-medium"
              prefix={<SearchIcon />}
            />
          </FormItem>
        </Form>
      </div>

      <div className="flex gap-x-4">
        <Button
          type="light"
          label="RAG Search"
          className="text-main border border-main"
          icon={<SearchIcon className="text-main" />}
          onClick={onRagSearch}
          size="medium"
        />
        <Button
          label={LABELS.DATA_SOURCE}
          icon={<AddIcon className="text-inherit" />}
          onClick={onAddDataSource}
          size="medium"
        />
      </div>
    </div>
  );
};
